import React from 'react';
import { connect } from 'react-redux';
import { List } from '@mui/material';
import { createActions } from '../../../../store';
import CollapsibleSwitchListItem from '../../../../../../list-items/CollapsibleSwitchListItem';
import CondensedListItem from '../../../../../../list-items/CondensedListItem';
import VisualizerShadowBlurListItem from './VisualizerShadowBlurListItem';
import VisualizerShadowColorListItem from './VisualizerShadowColorListItem';
import VisualizerShadowOpacityListItem from './VisualizerShadowOpacityListItem';

const VisualizerShadowListItem = (props) => {
    const { dropShadowSettingsEnabled, updateVisualizerSettings } = props;

    const onShadowEnabledChange = (value) => updateVisualizerSettings({ 
        dropShadowSettings: { enabled: value }
    });
    
    return (
        <CollapsibleSwitchListItem
            checked={dropShadowSettingsEnabled}
            text='Shadow'
            onChange={onShadowEnabledChange}
        >
            <List dense disablePadding>

                <VisualizerShadowColorListItem />

                <CondensedListItem
                    elements={[
                        {
                            width: 6,
                            component: <VisualizerShadowBlurListItem />
                        },
                        {
                            width: 6,
                            component: <VisualizerShadowOpacityListItem />
                        }
                    ]}
                />
            </List>
        </CollapsibleSwitchListItem>
    );
};

const mapStateToProps = (state) => {
    const { enabled: dropShadowSettingsEnabled } = state.createPreview.present.videoSettings.visualizer.dropShadowSettings;
    return { dropShadowSettingsEnabled };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerShadowListItem);